import { render, staticRenderFns } from "./JhmaFooter.vue?vue&type=template&id=757d464d&scoped=true&"
import script from "./JhmaFooter.vue?vue&type=script&lang=ts&"
export * from "./JhmaFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757d464d",
  null
  
)

export default component.exports